export default __webpack_public_path__ + "static/typography-ga-greek-7046660f6fedaa7dd343e4f5b99fca3d.png";